import { render, staticRenderFns } from "./AdditionalSections.vue?vue&type=template&id=0ecd3bc0&"
import script from "./AdditionalSections.vue?vue&type=script&lang=js&"
export * from "./AdditionalSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports